import React from 'react';
import PropTypes from 'prop-types';
import { errorLog } from '@bitComponents/utils/logUtils';
import { setUpPropsByDevice } from '@bitComponents/utils/common';
import './Image.scss';

/**
 * Stateless component to draw an image
 * @param {string} src path of the image.
 * @param {string} className wrapper class for img
 * @param {string} alt alt of the image.
 * @param {boolean} dynamicResize resize images
 * @returns {JSX} Component image JSX.
 */

const Image = (props) => {
  const myProps = setUpPropsByDevice(props);
  const { src, className, alt, align, dynamicResize, cySelector } = myProps;

  if (!src) {
    errorLog('[Image]: src must be !== null');
  }

  let dynamicCssClass = '';
  let classNameCss = className ? `${className}` : '';
  // align
  if (align !== 'none') {
    classNameCss = `${classNameCss} img_align--${align}`;
  }

  const currentOnLoad = (img) => {
    const { target } = img;
    const { width, height } = target;
    dynamicCssClass = height > width ? 'img--vertical' : 'img--horizontal';
    target.classList.add(dynamicCssClass);
  };

  return (
    <img
      cy-data={cySelector}
      className={classNameCss}
      alt={alt}
      src={src}
      onLoad={dynamicResize ? currentOnLoad : null}
    />
  );
};

Image.propTypes = {
  /**
   * {
   *  "info": "Dirección url de la imagen",
   *  "kind": "both",
   *  "beautifulName": "URL"
   * }
   */
  src: PropTypes.string.isRequired,
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Texto alternativo de la imagen",
   *  "kind": "both",
   *  "beautifulName": "Texto alternativo"
   * }
   */
  alt: PropTypes.string,
  /**
   * {
   *  "info": "Define si el tamaño de la imagen es dinámico",
   *  "kind": "both",
   *  "beautifulName": "Tamaño dinámico"
   * }
   */
  dynamicResize: PropTypes.bool,
  align: PropTypes.oneOf(['center', 'left', 'right', 'none']),
  /**
   * {
   *  "info": "Selector para cy-data",
   *  "kind": "both",
   *  "beautifulName": "Tamaño dinámico"
   * }
   */
  cySelector: PropTypes.string,
};

Image.defaultProps = {
  className: '',
  alt: '',
  dynamicResize: false,
  align: 'none',
  cySelector: '',
};

export default Image;
